import { SearchFormDataState } from "../Types/searchForm";

/**
 * static values for the form components in Asn, MiniAsn & FunnelSearch.
 * Stored in {Key: Value} notation inside the byId key.
 * When an alternative order is needed it is stored in the allIds array.
 */
const initialState: SearchFormDataState = {
  roomType: {
    byId: {
      1: { label: "Doppelzimmer" },
      2: { label: "Einzelzimmer" },
      3: { label: "Apartment" },
      4: { label: "Studio" },
      12: { label: "Familienzimmer" },
      5: { label: "Bungalow" },
      6: { label: "Suite" },
      8: { label: "Villa" },
      11: { label: "Duplexzimmer" },
      14: { label: "Deluxe-Zimmer" },
      15: { label: "Superiorzimmer" },
      16: { label: "Dreibettzimmer" },
      17: { label: "Mehrbettzimmer" },
    },
    allIds: [1, 2, 3, 4, 12, 5, 6, 8, 11, 14, 15, 16, 17],
  },

  mealType: {
    byId: {
      2: { label: "min. Frühstück" },
      3: { label: "min. Halbpension" },
      4: { label: "min. Vollpension" },
      5: { label: "min. All Inclusive" },
    },
    allIds: [2, 3, 4, 5],
  },

  hotelCriteria: {
    byId: {
      44: {
        label: "Nur für Erwachsene",
        icon: "adultsOnly",
      },
      30: {
        label: "Direkte Strandlage",
        icon: "beach",
      },
      32: {
        label: "Sandstrand",
        icon: "sandyBeach",
      },
      33: {
        label: "Pool",
        icon: "pool",
      },
      46: {
        label: "WLAN",
        icon: "wlan",
      },
      79: {
        label: "Haustiere erlaubt",
        icon: "IconPet",
      },
      80: {
        label: "Privater Pool",
        icon: "pool",
      },
      81: {
        label: "Swim up Pool",
        icon: "pool",
      },
      82: {
        label: "mind. 2 Schlafzimmer",
        icon: "bed",
      },
      83: {
        label: "separates Schlafzimmer",
        icon: "bed",
      },
    },
    allIds: [44, 32, 30, 33, 46],
  },

  // Categories that appear in the Room Type Filter section (Zimmer)
  roomTypeCategories: {
    allIds: [79, 80, 81, 82, 83] as const,
  },

  minRecommendation: {
    byId: {
      70: { label: "70%" },
      80: { label: "80%" },
      85: { label: "85%" },
      90: { label: "90%" },
      95: { label: "95%" },
      100: { label: "100%" },
    },
    allIds: [70, 80, 85, 90, 95, 100],
  },

  topFamily: {
    byId: {
      19: { label: "Familienfreundlich" },
      21: { label: "Animationsprogramm" },
      22: { label: "Kinderpool" },
      20: { label: "Kinderbetreuung" },
      23: { label: "Spielplatz" },
      77: { label: "Wasserrutschen" },
    },
    allIds: [19, 21, 22, 20, 23, 77],
  },

  topWellness: {
    byId: {
      40: { label: "Sauna" },
      39: { label: "Massage" },
    },
    allIds: [40, 39],
  },

  topSport: {
    byId: {
      12: { label: "Wassersport" },
      7: { label: "Fitness" },
      5: { label: "Golf" },
      4: { label: "Fahrrad/Mountainbike" },
      9: { label: "Tennis/Squash" },
      17: { label: "Tauchen" },
      16: { label: "Surfen" },
      34: { label: "Hallenbad" },
    },
    allIds: [12, 7, 5, 4, 9, 17, 16, 34],
  },

  transfer: {
    byId: {
      anything: {
        label: "beliebig (mit/ohne Transfer)",
        icon: "optional-large",
      },
      transfer: {
        label: "Transfer zum Hotel",
        icon: "bus-large",
      },
      rentalCar: {
        label: "Mietwagen ab Flughafen",
        icon: "car-large",
      },
    },
    allIds: ["anything", "transfer", "rentalCar"],
  },

  price: {
    byId: {
      6000: { label: "Beliebig" },
    },
    range: {
      min: 100,
      max: 6000,
      step: 100,
      default: 6000,
    },
  },

  railAndFly: {
    byId: {
      1: {
        label: "Zug zum Flughafen <small>innerhalb Deutschlands</small>",
        icon: "train-large",
      },
    },
    allIds: [1],
  },

  flightTime: {
    byId: {
      false: { label: "beliebig" },
      1: { label: "Morgens: 06:00 -11:59" },
      2: { label: "Nachmittags: 12:00 - 17:59" },
      3: { label: "Abends: 18:00 - 23:59" },
      4: { label: "Nachts: 00:00 - 05:59" },
    },
    allIds: [false, 1, 2, 3, 4],
  },
};

export default initialState;
